<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Footer (simple delete modal - no body content needed) -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"  
          type="button"  
          [disabled]="isSaveClicked"  
          (click)="deleteMaxLoanOverride()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
  <button class="cancel-button"  
          type="button"  
          (click)="cancel()">Cancel</button>
</div>

